import { MyFleetAcidListSource, MyFleetMode } from '../../udView/udview';
import { useAppSelector } from './store-hooks';

export default function useMyFleetIsDefined(): boolean {
    return useAppSelector((state) => {
        switch (state.settings.myFleetMode) {
            case MyFleetMode.airline:
                return state.settings.myFleetAirlines.length > 0;
            case MyFleetMode.airport:
                return !!state.settings.myFleetAirport;
            case MyFleetMode.disabled:
                return false;
            case MyFleetMode.acid:
                if (state.settings.myFleetAcidListSource === MyFleetAcidListSource.file) {
                    return state.global.myFleetFileAcidList.length > 0;
                }
                return true;
        }
    });
}
